import SVG from './SVG'
import * as T from './types'

export default (props: T.ISVGProps) => (
  <SVG
    {...props}
    viewBox="0 0 20 20"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18ZM10.88 4.5V9.64L14.51 13.27C14.7018 13.4678 14.7018 13.7822 14.51 13.98L13.98 14.51C13.7822 14.7018 13.4678 14.7018 13.27 14.51L9.27 10.51C9.17837 10.4159 9.12492 10.2912 9.12 10.16V4.5C9.12 4.22386 9.34386 4 9.62 4H10.38C10.6561 4 10.88 4.22386 10.88 4.5Z"
  />
)
